type SupportedLocales = 'nl_BE' | 'fr' | 'fr_CA' | 'es' | 'de' | 'en_US';

// mapping to translation files
export class LocaleUtils {
  public static readonly mapping: { [key: string]: SupportedLocales } = {
    // Spanish mappings
    'es-ES': 'es', // Spain Spanish → es
    es_es: 'es',
    es_ES: 'es',
    es: 'es',

    // German mappings
    'de-DE': 'de', // Germany German → de
    'de-CH': 'de', // Switzerland German → de
    de_de: 'de',
    de_ch: 'de',
    de: 'de',

    // Dutch mappings
    'nl-BE': 'nl_BE', // Belgium Dutch → nl_BE
    nl_be: 'nl_BE',
    nl: 'nl_BE',

    // French mappings
    'fr-BE': 'fr', // Belgium French → fr
    'fr-CA': 'fr_CA', // Canada French → fr_CA
    fr_be: 'fr',
    fr_ca: 'fr_CA',
    fr: 'fr',
    'fr-FR': 'fr',

    // English mappings
    'en-US': 'en_US',
    'en-AU': 'en_US',
    'en-GB': 'en_US',
    en_us: 'en_US',
    en_US: 'en_US',
    en: 'en_US',

    // Fallback mappings (unsupported locales → en_US)
    'zh-CN': 'en_US',
    zh_cn: 'en_US',
    it: 'en_US',
    ja: 'en_US',
    pt: 'en_US',
    ru: 'en_US',
    sk: 'en_US'
  };

  public static getLocale(): string {
    let languageCode: string = window.localStorage.getItem('languageCode');
    const localeFromUrl: string = LocaleUtils.getLocaleFromUrl();
    // Locale from url (coming from app) has priority
    // And set comming from app correctly
    if (languageCode !== localeFromUrl && this.checkUrlLocale(localeFromUrl)) {
      window.localStorage.setItem('languageCode', localeFromUrl);
      languageCode = localeFromUrl;
    }

    if (!languageCode) {
      languageCode = LocaleUtils.getLocaleFromCookie();
    }
    return languageCode || 'en-US';
  }

  public static getLocaleFromUrl(): string {
    return LocaleUtils.getParameterByName();
  }

  public static storageToUrlFormat(storageLocale: string): string {
    // Map storage format (with _) to URL format (with -)
    const storageToUrl: { [key: string]: string } = {
      en_US: 'en-US',
      de: 'de-DE',
      fr: 'fr-BE',
      fr_CA: 'fr-CA',
      nl_BE: 'nl-BE',
      es: 'es-ES'
    };
    return storageToUrl[storageLocale] || storageLocale;
  }

  private static checkUrlLocale(locale: string): boolean {
    // available builds
    return [
      'en-US',
      'de-DE',
      'fr-BE',
      'fr-CA',
      'nl-BE',
      'es-ES',
      'de-CH'
    ].includes(locale);
  }

  private static getLocaleFromCookie(): string {
    const match: Array<string> = document.cookie.match(
      new RegExp('locale' + '=([^;]+)')
    );
    if (match) {
      return LocaleUtils.mapping[match[1]];
    }
    return null;
  }

  private static getParameterByName(): string {
    const path = location.pathname; // Get the path part of the URL
    // Match both 2-char (ru) and 4-char (fr-BE) locale patterns
    const match = path.match(/\/([a-z]{2}(?:-[A-Z]{2})?)\//);
    return match ? match[1] : null; // Return the locale if found, otherwise null
  }
}
